import apple from '../assets/brands/Apple.png';
import asus from '../assets/brands/Asus.png';
import google from '../assets/brands/Google.png';
import Honor from '../assets/brands/Honor.png';
import Infinix from '../assets/brands/Infinix.png';
import iqoo from '../assets/brands/iQOO.png';
import Motorola from '../assets/brands/Motorola.png';
import Nothing from '../assets/brands/Nothing.png';
import Nokia from '../assets/brands/Nokia.png';
import OnePlus from '../assets/brands/OnePlus.png';
import Oppo from '../assets/brands/OPPO.png';
import Realme from '../assets/brands/Realme.png';
import Samsung from '../assets/brands/Samsung.png';
import Vivo from '../assets/brands/Vivo.png';
import Xiaomi from '../assets/brands/Xiaomi.png';
import poco from '../assets/brands/POCO.png';
import { toast } from 'react-hot-toast';
import { PiChatTextDuotone } from "react-icons/pi";

const brands = [
  {
    name: "Apple",
    image: apple,
    link: "#"
  }, 
  {
    name: "Asus",
    image: asus,
    link: "#"
  },
  {
    name: "Google",
    image: google,
    link: "#"
  },
  {
    name: "Honor",
    image: Honor,
    link: "#"
  },
  {
    name: "Infinix",
    image: Infinix,
    link: "#"
  },
  {
    name: "iqoo",
    image: iqoo,
    link: "#"
  },
  {
    name: "Motorola",
    image: Motorola,
    link: "#"
  },
  {
    name: "Nothing",
    image: Nothing,
    link: "#"
  },
  {
    name: "Nokia",
    image: Nokia,
    link: "#"
  },
  {
    name: "OnePlus",
    image: OnePlus,
    link: "#"
  },
  {
    name: "Oppo",
    image: Oppo,
    link: "#"
  },
  {
    name: "Realme",
    image: Realme,
    link: "#"
  },
  {
    name: "Samsung",
    image: Samsung,
    link: "#"
  },
  {
    name: "Vivo",
    image: Vivo,
    link: "#"
  },
  {
    name: "Xiaomi",
    image: Xiaomi,
    link: "#"
  },
  {
    name: "POCO",
    image: poco,
    link: "#"
  }
];

const Brand = () => {
        const handleAlert = () => {
        toast.error("The Online Services Currently Unavailable, Please visit or contact our store ");
        toast("Clear Your Queries By Chatting With Our Expert Team", {
            icon: <PiChatTextDuotone className="text-[#42C8B7]" size={24} />,
            duration: 10000,
        });
    }
    return (
        <div id="brand" className='w-full max-w-6xl mx-auto mt-4 sm:mt-6 md:mt-8 lg:mt-10 px-3 xs:px-4 sm:px-6'>
            <h2 className="text-lg sm:text-xl md:text-2xl font-bold mb-6 sm:mb-8 md:mb-10 text-start px-2">
                Our Exclusive Brands for Sales and Service
            </h2>
            <div className="grid grid-cols-3 xs:grid-cols-3 sm:grid-cols-4 md:grid-cols-5 lg:grid-cols-6 gap-3 xs:gap-4 sm:gap-5 md:gap-6 lg:gap-8">
                {brands.map((brand) => (
                    <div 
                        key={brand.name} 
                        onClick={handleAlert}
                        className='flex flex-col items-center justify-center shadow-[0_2px_8px_rgba(0,0,0,0.08)] hover:shadow-[0_4px_12px_rgba(0,0,0,0.12)] rounded-lg sm:rounded-xl transition-all duration-300 hover:scale-105 p-3 xs:p-4 sm:p-5 w-full aspect-square max-w-40 mx-auto'
                    >
                        <img 
                            src={brand.image} 
                            alt={brand.name} 
                            className="w-10 h-10 xs:w-12 xs:h-12 sm:w-14 sm:h-14 md:w-16 md:h-16 object-contain transition-transform duration-200" 
                        />
                        <p className='text-xs xs:text-sm font-medium mt-2 xs:mt-3 text-[#0F0F0F] text-center leading-tight'>
                            {brand.name}
                        </p>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Brand;